import { request } from './index';

export type UserType = {
  id: number;
  mobile: string;
  name: string;
  isSuperUser: boolean;
};

export async function fetchUser(): Promise<UserType> {
  return await request(true, { url: '/users/user' });
}

type CreateUserBaseType = {
  mobile: string;
  firstName: string;
  lastName: string;
  gender: '' | 'M' | 'F';
};

export type CreateUserDataType = CreateUserBaseType & { password: string; authKey: string };
export type CreateUserReturnType = CreateUserBaseType & {
  id: number;
  name: string;
  token: string;
};

export async function createUser(data: CreateUserDataType): Promise<CreateUserReturnType> {
  return await request(false, {
    url: '/users/users',
    method: 'POST',
    data
  });
}

export type ForgetPasswordDataType = { mobile: string };
export type ForgetPasswordReturnType = { uid: string };

export async function forgetPassword({
  mobile
}: ForgetPasswordDataType): Promise<ForgetPasswordReturnType> {
  return await request(false, {
    method: 'PATCH',
    url: '/users/users/send-sms-key',
    data: { mobile }
  });
}

export type CheckSMSKeyDataType = { uid: string; smsKey: string };
export type CheckSMSKeyReturnType = { token: string };

export async function checkSMSKey({
  uid,
  smsKey
}: CheckSMSKeyDataType): Promise<CheckSMSKeyReturnType> {
  return await request(false, {
    method: 'PATCH',
    url: `/users/users/check-sms-key/${uid}`,
    data: { smsKey }
  });
}

export type ResetPasswordDataType = { uid: string; token: string; password: string };
export type ResetPasswordReturnType = {};

export async function resetPassword({
  uid,
  token,
  password
}: ResetPasswordDataType): Promise<ResetPasswordReturnType> {
  return await request(false, {
    method: 'PATCH',
    url: `/users/users/reset-password/${uid}/${token}`,
    data: { password }
  });
}
